/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys, MyConnection } from '@/types'
import { useContext, useMemo, useState } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'

export const useGetMyConnections = () => {
  const axios = useContext(AxiosContext)
  const { setMyConnections, setMyConnectionsPagination } = useAppStore()
  const [existingConnections, pagination] = useAppStore(
    (state) => [state.user.myConnections, state.user.myConnectionsPagination],
    shallow,
  )

  const getMyConnections = useMutation({
    mutationKey: [ReactQueryKeys.GET_MY_CONNECTIONS],
    mutationFn: async (page: number) => {
      const response = await axios.api.post('ajax/circles', {
        requestType: 'connList',
        format: 'json',
        full: 1,
        pageNo: page,
      })

      const responseData = response.data

      if (!responseData.isError) {
        const connections = response.data?.connections || []
        let combined = [...connections]
        if (page > 1) {
          combined = [...(existingConnections || []), ...connections]
        }
        setMyConnections(combined)
        setMyConnectionsPagination(responseData.pagination)
      }
      return response.data?.connections || []
    },
  })

  const canLoadMore = useMemo(
    () => (!pagination ? false : pagination.currentPage < pagination.totalPage),
    [pagination],
  )

  const loadMore = () => {
    if (canLoadMore && pagination && !getMyConnections.isLoading) {
      getMyConnections.mutate(pagination.currentPage + 1)
    }
  }

  return {
    getMyConnections,
    canLoadMore,
    loadMore,
    loadingNextPage: getMyConnections.isLoading && (pagination?.currentPage || 1) > 1,
  }
}
